<script lang="ts">
import { cloneVNode, defineComponent, h, mergeProps, type Component, type PropType } from 'vue';

export interface UiConditionalWrapperProps {
  condition: boolean;
  wrapper: Component | string;
  wrapperProps?: Record<string, any>;
}

export default defineComponent({
  name: 'UiConditionalWrapper',
  inheritAttrs: false,
  props: {
    condition: {
      type: Boolean,
      required: true,
    },
    wrapper: {
      type: [Object, String] as PropType<Component | string>,
      required: true,
    },
    wrapperProps: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
  },
  render() {
    const children = this.$slots.default?.() || [];
    const attrs = this.$attrs;

    if (this.condition && this.wrapper) {
      // When wrapper is a string (HTML tag), pass children directly
      // When wrapper is a component, pass as a function for slots
      const isString = typeof this.wrapper === 'string';
      return h(
        this.wrapper, 
        mergeProps(attrs, this.wrapperProps), 
        isString ? children : () => children
      );
    }

    return children.length === 1 ? cloneVNode(children[0], attrs) : children;
  },
});
</script>
